export default __webpack_public_path__ + "static/media/01AW1OCT66.27a5b86b.jpg";